import React from "react";

import cn from "classnames";

import LoadingDots from "@app/component/LoadingDots";

import styles from "./LoadingStatusPanel.module.scss";

interface Props {
  className?: string;
  loading?: boolean;
}

const LoadingStatusPanel: React.FC<Props> = ({ className, loading }) => {
  if (!loading) {
    return null;
  }

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.content}>
        <LoadingDots />
      </div>
    </div>
  );
};

export default LoadingStatusPanel;
